/* From the approved auth mockup's `.pw`, `.pw-bar`, `.pw-lb`, `.pwl` and `.pwc` rules. */

.meter {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin: var(--space-1) var(--space-0) var(--space-3);
}

.bar {
  display: flex;
  flex: 1;
  gap: var(--space-1);
}

/* 5px is a bar's thickness, not a spacing decision — height carries no design token by design
 * (see stylelint.config.js), so it is written as it is drawn. */
.segment {
  flex: 1;
  height: 5px;
  border-radius: var(--r-pill);
  background: var(--bg-sunken);
  transition-property: background-color;
  transition-duration: var(--dur-fast);
  transition-timing-function: var(--ease);
}

/* A met criterion fills its segment in ink, not in the confirming green — the mockup specifies a
 * colour for the ALL-met state only (`.pw-bar.s4`), and painting one satisfied criterion green says
 * "good" about a password the form is about to refuse. Ink reads as progress; green arrives with
 * `.complete` below, which is the state the specimen actually draws. */
.segmentMet {
  background: var(--text);
}

/* Fixed width so the bar does not resize as the word changes from "Słabe" to "Średnie". */
.tier {
  width: 46px;
  font-family: var(--font-body);
  font-size: var(--fs-micro);
  font-weight: var(--fw-bold);
  text-align: right;
  color: var(--text-2);
}

/* All four met — the mockup's `.pw-bar.s4` / `.pw-lb`. */
.complete .segmentMet {
  background: var(--good);
}

.complete .tier {
  color: var(--good-ink);
}

/* Two columns, as the mockup draws them. The row gap is `--space-2` where the specimen has 6px:
 * the scale has no 6px step, and inventing one for a single grid would be a token nobody can name. */
.criteria {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-2) var(--space-3);
  margin: var(--space-0) var(--space-0) var(--space-4);
  padding: var(--space-0);
  list-style: none;
}

.criterion {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
  font-family: var(--font-body);
  font-size: var(--fs-micro);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
}

.criterionMet {
  color: var(--good-ink);
}

.criterionIcon {
  flex: none;
  width: var(--space-3);
  height: var(--space-3);
  stroke-width: 3;
}
